import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme) => ({
  wrapper: {
    padding: "24px",
  },
}));

export default styles;
